import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import Tree from "Tree";
import $http from '$http';

export default {
    mixins: [services],
    components: {
        Tree
    },
    props: {},
    created() {},
    data() {
        return {
            actionPartmentVisible: false,
            loading: false,
            TreeDataList: [], //树级数据
            Partment: [],
        }
    },
    methods: {
        show(opts) {
            this.actionPartmentVisible = true
        },
        // 点击树级部门将当前选中的节点赋值给Partment
        handleActionPartment(value) {
            console.log(value)
            this.Partment = value
        },
        // 选择部门确定按钮
        sureBtn() {
            this.$emit('deptData', this.Partment)
            this.actionPartmentVisible = false
        },

    },
    created() {
        this.getEmployee();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AddEmployee/components/chooseDept/vm.js